/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Microsoftuserdata2Inputs */



/**

* @param {_Field_Microsoftuserdata2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_microsoftuserdata2 = /** @type {((inputs?: _Field_Microsoftuserdata2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Microsoftuserdata2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Microsoft Daten")
});
export { _field_microsoftuserdata2 as "_field_microsoftUserData" }